// src/component/ResetPassword.js
import React from 'react';
import { TextField, Button } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';


const ResetPassword = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const resetOnSubmit = (data) => {
    // 在這裡處理重設密碼表單提交的資料
    console.log(data);

    fetch('https://macct.tw/api/resetpassword', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'credentials': 'include'
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then(data => {
      if(data.success){
          alert("重設成功，已寄出密碼重設信");
          window.location.reload();
      }else{
          alert("重設成功 \n \n",data.message);
      }
    })
    .catch(error => {
    console.error('Error:', error);
    });
  };

  return (
    <div className="reset-password-container">
    <div className="reset-password-form">
      <h2>Reset Password</h2>
      <form onSubmit={handleSubmit(resetOnSubmit)}>
        <Controller
          name="email"
          control={control}
          defaultValue=""
          rules={{
            required: 'Email is required',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Invalid email address',
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Email"
              error={!!errors.email}
              helperText={errors.email?.message}
            />
          )}
        />
        <br /><br />
        <Button type="submit" variant="contained" color="primary">
          Reset Password
        </Button>
      </form>
      </div>
    </div>
  );
};

export default ResetPassword;